// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { CircularProgress, Box, Typography } from '@mui/material';
// import SharedHeader from '../../components/SharedHeader';
// import SharedFooter from '../../components/SharedFooter';
// import { tokenStorage } from '../../utils/tokenStorage';
// import { getHealthLogRange } from '../../services/api';

// const MEAL_LABELS = {
//   BREAKFAST: { label: 'Breakfast', emoji: '🌅', color: 'bg-orange-100 text-orange-900' },
//   LUNCH: { label: 'Lunch', emoji: '☀️', color: 'bg-yellow-100 text-yellow-900' },
//   DINNER: { label: 'Dinner', emoji: '🌙', color: 'bg-purple-100 text-purple-900' },
// };

// // Format an ISO date string "YYYY-MM-DD" to "9 May 2026"
// function formatDate(isoDate) {
//   if (!isoDate) return '';
//   const d = new Date(isoDate);
//   return d.toLocaleDateString('en-GB', {
//     day: 'numeric',
//     month: 'short',
//     year: 'numeric',
//   });
// }

// // Sugar value → status color
// function sugarStatus(value) {
//   if (value == null) return { label: '—', color: 'text-gray-500' };
//   if (value < 70) return { label: 'Low', color: 'text-blue-600' };
//   if (value <= 140) return { label: 'Normal', color: 'text-green-600' };
//   if (value <= 199) return { label: 'High', color: 'text-orange-600' };
//   return { label: 'Very High', color: 'text-red-600' };
// }

// export default function HealthLogDashboard() {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [authLoading, setAuthLoading] = useState(true);

//   const [logs, setLogs] = useState([]);
//   const [logsLoading, setLogsLoading] = useState(true);
//   const [logsError, setLogsError] = useState(null);

//   // Default range: last 7 days including today
//   const today = new Date();
//   const sevenDaysAgo = new Date();
//   sevenDaysAgo.setDate(today.getDate() - 6);

//   const toIsoDate = (d) => d.toISOString().slice(0, 10);

//   const [fromDate, setFromDate] = useState(toIsoDate(sevenDaysAgo));
//   const [toDate, setToDate] = useState(toIsoDate(today));

//   // Auth gate (matches UserDashboard pattern)
//   useEffect(() => {
//     const storedUser = tokenStorage.getUser();
//     const hasToken = tokenStorage.isLoggedIn();

//     if (storedUser && hasToken) {
//       setUser(storedUser);
//     } else {
//       navigate('/');
//     }
//     setAuthLoading(false);
//   }, [navigate]);

//   // Fetch logs on date range change
//   const fetchLogs = useCallback(() => {
//     setLogsLoading(true);
//     setLogsError(null);

//     getHealthLogRange(fromDate, toDate)
//       .then((res) => {
//         if (res.data.status === 200 && Array.isArray(res.data.data)) {
//           // Newest first
//           const sorted = [...res.data.data].sort((a, b) =>
//             b.date.localeCompare(a.date)
//           );
//           setLogs(sorted);
//         } else {
//           console.error('Unexpected response:', res.data);
//           setLogsError(res.data.message || 'Could not load health logs');
//         }
//       })
//       .catch((err) => {
//         console.error('Error fetching health logs:', err);
//         setLogsError('Failed to load health logs');
//       })
//       .finally(() => setLogsLoading(false));
//   }, [fromDate, toDate]);

//   useEffect(() => {
//     if (user) fetchLogs();
//   }, [user, fetchLogs]);

//   if (authLoading || !user) {
//     return (
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           justifyContent: 'center',
//           height: '100vh',
//         }}
//       >
//         <CircularProgress />
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
//           Loading...
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <>
//       <SharedHeader />

//       <main className="max-w-5xl mx-auto p-6">
//         <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
//           <div>
//             <h1 className="text-3xl font-semibold">Health Log</h1>
//             <p className="text-sm text-gray-600 mt-1">
//               Sugar and weight readings for {user.userName || user.userEmail}
//             </p>
//           </div>
//           <button
//             onClick={fetchLogs}
//             className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
//           >
//             Refresh
//           </button>
//         </div>

//         {/* Date range filter */}
//         <div className="bg-white shadow p-4 rounded-lg mb-6 flex gap-4 flex-wrap items-end">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">From</label>
//             <input
//               type="date"
//               value={fromDate}
//               max={toDate}
//               onChange={(e) => setFromDate(e.target.value)}
//               className="border border-gray-300 rounded px-3 py-2"
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
//             <input
//               type="date"
//               value={toDate}
//               min={fromDate}
//               max={toIsoDate(today)}
//               onChange={(e) => setToDate(e.target.value)}
//               className="border border-gray-300 rounded px-3 py-2"
//             />
//           </div>
//           <QuickRangeButtons
//             onPick={(days) => {
//               const end = new Date();
//               const start = new Date();
//               start.setDate(end.getDate() - (days - 1));
//               setFromDate(toIsoDate(start));
//               setToDate(toIsoDate(end));
//             }}
//           />
//         </div>

//         {/* Summary cards */}
//         {!logsLoading && !logsError && logs.length > 0 && (
//           <SummaryCards logs={logs} />
//         )}

//         {/* Logs */}
//         <div className="bg-white shadow p-6 rounded-lg min-h-[300px]">
//           {logsLoading ? (
//             <div className="flex justify-center py-12">
//               <CircularProgress />
//             </div>
//           ) : logsError ? (
//             <div className="text-center py-12 text-red-600">{logsError}</div>
//           ) : logs.length === 0 ? (
//             <div className="text-center py-12 text-gray-500">
//               No entries found for this date range.
//             </div>
//           ) : (
//             <div className="space-y-6">
//               {logs.map((day) => (
//                 <DayCard key={day.date} day={day} />
//               ))}
//             </div>
//           )}
//         </div>
//       </main>

//       <SharedFooter />
//     </>
//   );
// }

// // Quick filter buttons: 7 / 14 / 30 days
// function QuickRangeButtons({ onPick }) {
//   const ranges = [7, 14, 30];
//   return (
//     <div className="flex gap-2 ml-auto">
//       {ranges.map((d) => (
//         <button
//           key={d}
//           onClick={() => onPick(d)}
//           className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg"
//         >
//           {d} days
//         </button>
//       ))}
//     </div>
//   );
// }

// // Aggregate stats for the visible range
// function SummaryCards({ logs }) {
//   const allSugar = logs.flatMap((d) => d.sugarEntries.map((s) => s.valueMgDl));
//   const allWeights = logs
//     .map((d) => d.weightEntry?.weightKg)
//     .filter((w) => w != null);

//   const sugarAvg =
//     allSugar.length > 0
//       ? Math.round(allSugar.reduce((a, b) => a + b, 0) / allSugar.length)
//       : null;
//   const sugarMin = allSugar.length > 0 ? Math.min(...allSugar) : null;
//   const sugarMax = allSugar.length > 0 ? Math.max(...allSugar) : null;
//   const weightLatest = allWeights.length > 0 ? allWeights[0] : null;

//   return (
//     <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
//       <StatCard label="Avg Sugar" value={sugarAvg ? `${sugarAvg}` : '—'} unit="mg/dL" />
//       <StatCard label="Lowest" value={sugarMin ?? '—'} unit="mg/dL" tone="text-blue-600" />
//       <StatCard label="Highest" value={sugarMax ?? '—'} unit="mg/dL" tone="text-red-600" />
//       <StatCard
//         label="Latest Weight"
//         value={weightLatest ?? '—'}
//         unit="kg"
//       />
//     </div>
//   );
// }

// function StatCard({ label, value, unit, tone = 'text-gray-900' }) {
//   return (
//     <div className="bg-white shadow rounded-lg p-4">
//       <div className="text-sm text-gray-500">{label}</div>
//       <div className={`text-2xl font-bold mt-1 ${tone}`}>
//         {value}{' '}
//         <span className="text-sm font-normal text-gray-500">{unit}</span>
//       </div>
//     </div>
//   );
// }

// // One day's entries
// function DayCard({ day }) {
//   const meals = ['BREAKFAST', 'LUNCH', 'DINNER'];

//   return (
//     <div className="border border-gray-200 rounded-lg p-4">
//       <div className="flex items-center justify-between mb-3">
//         <h3 className="text-lg font-semibold">{formatDate(day.date)}</h3>
//         {day.weightEntry && (
//           <div className="text-sm text-gray-600">
//             ⚖️ Weight:{' '}
//             <span className="font-semibold text-gray-900">
//               {day.weightEntry.weightKg} kg
//             </span>
//           </div>
//         )}
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
//         {meals.map((mt) => {
//           const entry = day.sugarEntries.find((s) => s.mealTime === mt);
//           const meta = MEAL_LABELS[mt];
//           const status = sugarStatus(entry?.valueMgDl);

//           return (
//             <div
//               key={mt}
//               className={`rounded-lg p-3 ${meta.color}`}
//             >
//               <div className="flex items-center gap-2 mb-1">
//                 <span className="text-xl">{meta.emoji}</span>
//                 <span className="font-medium">{meta.label}</span>
//               </div>
//               {entry ? (
//                 <div>
//                   <div className="text-2xl font-bold">
//                     {entry.valueMgDl}{' '}
//                     <span className="text-sm font-normal">mg/dL</span>
//                   </div>
//                   <div className={`text-xs font-semibold ${status.color}`}>
//                     {status.label}
//                   </div>
//                 </div>
//               ) : (
//                 <div className="text-sm text-gray-600 italic">No entry</div>
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';
import SharedHeader from '../../components/SharedHeader';
import SharedFooter from '../../components/SharedFooter';
import { tokenStorage } from '../../utils/tokenStorage';
import { getHealthLogRange } from '../../services/api';

const MEAL_LABELS = {
  BREAKFAST: { label: 'Breakfast', emoji: '🌅', color: 'bg-orange-100 text-orange-900' },
  LUNCH: { label: 'Lunch', emoji: '☀️', color: 'bg-yellow-100 text-yellow-900' },
  DINNER: { label: 'Dinner', emoji: '🌙', color: 'bg-purple-100 text-purple-900' },
};

// Format a Date to "YYYY-MM-DD" using LOCAL date parts (not UTC).
// Using d.toISOString() would shift the date back 1 day in IST after ~6:30 PM UTC.
function toIsoDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Format an ISO date string "YYYY-MM-DD" to "9 May 2026"
function formatDate(isoDate) {
  if (!isoDate) return '';
  // Parse as UTC to avoid the same off-by-one issue, then format in IST
  const d = new Date(`${isoDate}T00:00:00+05:30`);
  return d.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'Asia/Kolkata',
  });
}

// Format an ISO timestamp to a clinical-friendly time, in IST.
// Always shows IST so the time matches when the user logged the reading,
// regardless of where the page is being viewed.
function formatTime(isoTimestamp) {
  if (!isoTimestamp) return '';
  const d = new Date(isoTimestamp);
  return d.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });
}

// Sugar value → status color
function sugarStatus(value) {
  if (value == null) return { label: '—', color: 'text-gray-500' };
  if (value < 70) return { label: 'Low', color: 'text-blue-600' };
  if (value <= 140) return { label: 'Normal', color: 'text-green-600' };
  if (value <= 199) return { label: 'High', color: 'text-orange-600' };
  return { label: 'Very High', color: 'text-red-600' };
}

export default function HealthLogDashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const [logs, setLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(true);
  const [logsError, setLogsError] = useState(null);

  // Default range: last 7 days including today (in IST)
  const today = new Date();
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 6);

  const [fromDate, setFromDate] = useState(toIsoDate(sevenDaysAgo));
  const [toDate, setToDate] = useState(toIsoDate(today));

  // Auth gate (matches UserDashboard pattern)
  useEffect(() => {
    const storedUser = tokenStorage.getUser();
    const hasToken = tokenStorage.isLoggedIn();

    if (storedUser && hasToken) {
      setUser(storedUser);
    } else {
      navigate('/');
    }
    setAuthLoading(false);
  }, [navigate]);

  // Fetch logs on date range change
  const fetchLogs = useCallback(() => {
    setLogsLoading(true);
    setLogsError(null);

    getHealthLogRange(fromDate, toDate)
      .then((res) => {
        if (res.data.status === 200 && Array.isArray(res.data.data)) {
          // Newest first
          const sorted = [...res.data.data].sort((a, b) =>
            b.date.localeCompare(a.date)
          );
          setLogs(sorted);
        } else {
          console.error('Unexpected response:', res.data);
          setLogsError(res.data.message || 'Could not load health logs');
        }
      })
      .catch((err) => {
        console.error('Error fetching health logs:', err);
        setLogsError('Failed to load health logs');
      })
      .finally(() => setLogsLoading(false));
  }, [fromDate, toDate]);

  useEffect(() => {
    if (user) fetchLogs();
  }, [user, fetchLogs]);

  if (authLoading || !user) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Loading...
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <SharedHeader />

      <main className="max-w-5xl mx-auto p-6">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
          <div>
            <h1 className="text-3xl font-semibold">Health Log</h1>
            <p className="text-sm text-gray-600 mt-1">
              Sugar and weight readings for {user.userName || user.userEmail}
            </p>
          </div>
          <button
            onClick={fetchLogs}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
          >
            Refresh
          </button>
        </div>

        {/* Date range filter */}
        <div className="bg-white shadow p-4 rounded-lg mb-6 flex gap-4 flex-wrap items-end">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">From</label>
            <input
              type="date"
              value={fromDate}
              max={toDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="border border-gray-300 rounded px-3 py-2"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">To</label>
            <input
              type="date"
              value={toDate}
              min={fromDate}
              max={toIsoDate(new Date())}
              onChange={(e) => setToDate(e.target.value)}
              className="border border-gray-300 rounded px-3 py-2"
            />
          </div>
          <QuickRangeButtons
            onPick={(days) => {
              const end = new Date();
              const start = new Date();
              start.setDate(end.getDate() - (days - 1));
              setFromDate(toIsoDate(start));
              setToDate(toIsoDate(end));
            }}
          />
        </div>

        {/* Summary cards */}
        {!logsLoading && !logsError && logs.length > 0 && (
          <SummaryCards logs={logs} />
        )}

        {/* Logs */}
        <div className="bg-white shadow p-6 rounded-lg min-h-[300px]">
          {logsLoading ? (
            <div className="flex justify-center py-12">
              <CircularProgress />
            </div>
          ) : logsError ? (
            <div className="text-center py-12 text-red-600">{logsError}</div>
          ) : logs.length === 0 ? (
            <div className="text-center py-12 text-gray-500">
              No entries found for this date range.
            </div>
          ) : (
            <div className="space-y-6">
              {logs.map((day) => (
                <DayCard key={day.date} day={day} />
              ))}
            </div>
          )}
        </div>
      </main>

      <SharedFooter />
    </>
  );
}

// Quick filter buttons: 7 / 14 / 30 days
function QuickRangeButtons({ onPick }) {
  const ranges = [7, 14, 30];
  return (
    <div className="flex gap-2 ml-auto">
      {ranges.map((d) => (
        <button
          key={d}
          onClick={() => onPick(d)}
          className="px-3 py-2 text-sm bg-gray-100 hover:bg-gray-200 rounded-lg"
        >
          {d} days
        </button>
      ))}
    </div>
  );
}

// Aggregate stats for the visible range
function SummaryCards({ logs }) {
  const allSugar = logs.flatMap((d) => d.sugarEntries.map((s) => s.valueMgDl));
  const allWeights = logs
    .map((d) => d.weightEntry?.weightKg)
    .filter((w) => w != null);

  const sugarAvg =
    allSugar.length > 0
      ? Math.round(allSugar.reduce((a, b) => a + b, 0) / allSugar.length)
      : null;
  const sugarMin = allSugar.length > 0 ? Math.min(...allSugar) : null;
  const sugarMax = allSugar.length > 0 ? Math.max(...allSugar) : null;
  const weightLatest = allWeights.length > 0 ? allWeights[0] : null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <StatCard label="Avg Sugar" value={sugarAvg ? `${sugarAvg}` : '—'} unit="mg/dL" />
      <StatCard label="Lowest" value={sugarMin ?? '—'} unit="mg/dL" tone="text-blue-600" />
      <StatCard label="Highest" value={sugarMax ?? '—'} unit="mg/dL" tone="text-red-600" />
      <StatCard
        label="Latest Weight"
        value={weightLatest ?? '—'}
        unit="kg"
      />
    </div>
  );
}

function StatCard({ label, value, unit, tone = 'text-gray-900' }) {
  return (
    <div className="bg-white shadow rounded-lg p-4">
      <div className="text-sm text-gray-500">{label}</div>
      <div className={`text-2xl font-bold mt-1 ${tone}`}>
        {value}{' '}
        <span className="text-sm font-normal text-gray-500">{unit}</span>
      </div>
    </div>
  );
}

// One day's entries
function DayCard({ day }) {
  const meals = ['BREAKFAST', 'LUNCH', 'DINNER'];

  return (
    <div className="border border-gray-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h3 className="text-lg font-semibold">{formatDate(day.date)}</h3>
        {day.weightEntry && (
          <div className="text-sm text-gray-600">
            ⚖️ Weight:{' '}
            <span className="font-semibold text-gray-900">
              {day.weightEntry.weightKg} kg
            </span>
            {day.weightEntry.createdAt && (
              <span className="text-xs text-gray-500 ml-2">
                at {formatTime(day.weightEntry.createdAt)}
              </span>
            )}
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {meals.map((mt) => {
          const entry = day.sugarEntries.find((s) => s.mealTime === mt);
          const meta = MEAL_LABELS[mt];
          const status = sugarStatus(entry?.valueMgDl);

          return (
            <div
              key={mt}
              className={`rounded-lg p-3 ${meta.color}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xl">{meta.emoji}</span>
                <span className="font-medium">{meta.label}</span>
              </div>
              {entry ? (
                <div>
                  <div className="text-2xl font-bold">
                    {entry.valueMgDl}{' '}
                    <span className="text-sm font-normal">mg/dL</span>
                  </div>
                  <div className="flex items-center justify-between mt-1 flex-wrap gap-1">
                    <span className={`text-xs font-semibold ${status.color}`}>
                      {status.label}
                    </span>
                    {entry.createdAt && (
                      <span className="text-xs text-gray-700">
                        🕐 {formatTime(entry.createdAt)}
                      </span>
                    )}
                  </div>
                </div>
              ) : (
                <div className="text-sm text-gray-600 italic">No entry</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}